<template>
  <div>
    <el-row>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header"></i>
          <span>自我诊断</span>
        </div>
        <DiagToDrugAndAcupoint></DiagToDrugAndAcupoint>
      </el-card>
    </el-row>


    <el-row>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header"></i>
          <span>火爆药品</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-table
                :data="drug_goods_prepare_alert_list.slice(0,drug_goods_prepare_alert_list.length/2)"
                :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                :row-class-name="tableRowClassName"
                style="width: 100%;">
              <el-table-column prop="index" label="序号"></el-table-column>
              <el-table-column prop="drug_name" label="药品名称"></el-table-column>
              <el-table-column prop="cnt" label="最近销量"></el-table-column>
              <el-table-column prop="drug_hot" label="销量火爆指数"></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <el-table
                :data="drug_goods_prepare_alert_list.slice(drug_goods_prepare_alert_list.length/2)"
                :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                :row-class-name="tableRowClassName"
                style="width: 100%;">
              <el-table-column prop="index" label="序号"></el-table-column>
              <el-table-column prop="drug_name" label="药品名称"></el-table-column>
              <el-table-column prop="cnt" label="最近销量"></el-table-column>
              <el-table-column prop="drug_hot" label="销量火爆指数"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>
    </el-row>


  </div>
</template>
<script>


import DiagToDrugAndAcupoint from "@/views/out_service/DiagToDrugAndAcupoint";


export default {
  name: "PatientRecommend",
  components: {

    DiagToDrugAndAcupoint,

  },
  data() {
    return {
      results: null,
      patient_id: null,
      drug_goods_prepare_alert_list: null,
      activeName: 'yptj',

    }
  },
  mounted() {
    // this.query_pred_disease()
    this.getDrug_goods_prepare_alert_list()
  },
  methods: {
    tableRowClassName({rowIndex}) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
    getDrug_goods_prepare_alert_list() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/drug_goods_prepare_alert_list").then((res) => {
        // console.log(res);
        this.drug_goods_prepare_alert_list = res.data.data;
      })
    },
  }
}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
/deep/ .el-tag {
  background-color: #3C3F4A;
  border-color: #409EFF;
  margin-top: 2px;
}
</style>
